import { FC, useMemo, useCallback } from 'react';
import intl from 'react-intl-universal';
import { FormItem, Dropdown } from '@getsynapse/design-system';
import { Option } from 'utils/customTypes';
import { PROJECT_HEALTH } from 'utils/constants/projectsList';
import { ProjectHealth } from 'utils/types/projectsList';

interface ProjectHealthFilterProps {
  onSelect: (selected: ProjectHealth[]) => void;
  selected?: ProjectHealth[];
}

const ProjectHealthFilter: FC<ProjectHealthFilterProps> = ({
  selected,
  onSelect,
}) => {
  const healthOptions = useMemo(() => {
    return Object.keys(PROJECT_HEALTH).map((key) => ({
      value: PROJECT_HEALTH[key as keyof typeof PROJECT_HEALTH],
      label: intl.get(`PROJECT_DETAIL.HEALTH_OPTIONS.${key}`),
    }));
  }, []);

  const selectedOptions = useMemo(() => {
    return healthOptions.filter((option) =>
      selected?.includes(option.value as ProjectHealth)
    );
  }, [healthOptions, selected]);

  const handleOnChange = useCallback(
    (selectedOptions: Option[]) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      onSelect(selectedValues as ProjectHealth[]);
    },
    [onSelect]
  );

  return (
    <FormItem label={intl.get('PROJECT_DETAIL.HEALTH')}>
      <Dropdown
        options={healthOptions}
        values={selectedOptions}
        onChange={handleOnChange}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-health-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectHealthFilter;
